import { Grid, makeStyles, Theme, withWidth } from '@material-ui/core';
import { GridSpacing } from '@material-ui/core/Grid';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import React from 'react';

function getSpacing(width: Breakpoint): GridSpacing {
  if (width === 'xs' || width === 'sm') {
    return 2;
  }

  return 3;
}

export const useCardStyles = makeStyles(({ breakpoints }: Theme) => ({
  card: {
    [breakpoints.up('md')]: {
      maxWidth: 416,
    },
  },
}));

const useStyles = makeStyles(({ breakpoints, spacing }: Theme) => ({
  cardsSpace: {
    [breakpoints.only('xs')]: {
      paddingLeft: spacing(1),
      paddingRight: spacing(1),
    },

    [breakpoints.only('sm')]: {
      paddingLeft: spacing(3),
      paddingRight: spacing(3),
    },
  },
}));

export default withWidth()(function GridContainer({
  children,
  width,
  cards,
  className = '',
  ...props
}) {
  const classes = useStyles();

  return (
    <Grid
      container
      {...props}
      spacing={getSpacing(width)}
      className={`${cards ? classes.cardsSpace : ''} ${className}`}
    >
      {children}
    </Grid>
  );
});
